import React from 'react'
function Footer() {
  return (
    <footer>
      © Zlobin Anton, RTU MIREA 2023
    </footer>
  )
}
export default Footer;